module.exports = __webpack_public_path__ + "static/first-afe4c776c09c0875d59d0027e4219104.jpg";